/**
 * @flow
 * @relayHash 9b34959fa3175d7ef221b7503b102a92
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type remove_selected_front_square_box_by_guest_mutationInput = {|
  game1_answer_id: string,
  clientMutationId?: ?string,
|};
export type removeSelectedFrontSquareBoxByGuestMutationVariables = {|
  input: remove_selected_front_square_box_by_guest_mutationInput
|};
export type removeSelectedFrontSquareBoxByGuestMutationResponse = {|
  +removeSelectedFrontSquareBoxByGuest: ?{|
    +code: ?number,
    +message: ?string,
  |}
|};
export type removeSelectedFrontSquareBoxByGuestMutation = {|
  variables: removeSelectedFrontSquareBoxByGuestMutationVariables,
  response: removeSelectedFrontSquareBoxByGuestMutationResponse,
|};
*/


/*
mutation removeSelectedFrontSquareBoxByGuestMutation(
  $input: remove_selected_front_square_box_by_guest_mutationInput!
) {
  removeSelectedFrontSquareBoxByGuest(input: $input) {
    code
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "remove_selected_front_square_box_by_guest_mutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "removeSelectedFrontSquareBoxByGuest",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "remove_selected_front_square_box_by_guest_mutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "removeSelectedFrontSquareBoxByGuestMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "removeSelectedFrontSquareBoxByGuestMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "removeSelectedFrontSquareBoxByGuestMutation",
    "id": null,
    "text": "mutation removeSelectedFrontSquareBoxByGuestMutation(\n  $input: remove_selected_front_square_box_by_guest_mutationInput!\n) {\n  removeSelectedFrontSquareBoxByGuest(input: $input) {\n    code\n    message\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd3e287a4518cdb662e8f87d64b25defb';
module.exports = node;
